export default __webpack_public_path__ + "locales/ko-KR/Article.json?hash=ecedd7196ed2dd1443e32df949bf15e6";